import { japaneseWordExpressions } from "./expressions";

/**
 *
 * @param text {string} - 表示する文字列（カテゴリ名やテキストなど）
 * @param word {string} - 検索対象の文字列
 *
 * @returns {string} - 正規表現に合致した場合は、ハイライトを付与した文字列
 *
 */
export const matchedWordToHighlightConverter = (word: string, text: string): string => {
	const regex = japaneseWordExpressions(word);
	return text.replace(regex, '<span style="background-color: yellow;">$1</span>');
};
